
export const zfill = (v, n, str) => {
  if (String(v).length > n) {
    return String(v)
  } else {
    return Array(n - String(v).length + 1).join(str || '0') + v
  }
}

export const formatMs = (input, full) => {
  if (input || input === 0) {
    let ms = parseInt(input, 10)
    let signo = ''
    if (ms < 0) {
      // signo = '-'
      return '---'
    }
    ms = Math.abs(ms)

    let s = Math.floor(ms / 1000)
    let m = Math.floor(s / 60)
    let h = Math.floor(m / 60)
    s = s % 60
    m = m % 60

    ms = ms % 1000
    if (typeof full === 'undefined' || !full) {
      // redondeamos o segundo superior
      if (ms) {
        s++
      }

      if (s === 60) {
        m += 1
        s = 0
      }
      if (m === 60) {
        h += 1
        m = 0
      }

      return signo + zfill(h, 2) + ':' + zfill(m, 2) + ':' + zfill(s, 2)
    } else {
      return signo + zfill(h, 2) + ':' + zfill(m, 2) + ':' + zfill(s, 2) + '.' + zfill(ms, 3)
    }
  }
  return ''
}

export const formatMsShort = (input, full) => {
  const v = formatMs(input, full)
  if (v.startsWith('00:')) {
    return v.substr(3)
  }
  return ''
}

export const msAhora = () => {
  const d = new Date()
  const offset = d.getTimezoneOffset()
  let ms = d.getMilliseconds() +
    1000 * (d.getSeconds() + 60 * (d.getMinutes() + 60 * d.getHours()))
  // 60 e o Timezone Offset do guntime
  // alert(ms)
  // alert(offset)
  return ms + offset - 60
}

/**
 * Ms pero no desde el inicio del día: desde el inicio del día de la carrera.
 *
 * @param fecha_inicio string formato 'yyyy-mm-dd'
 */
export const msFullAhora = (fechaInicio) => {
  const d = new Date()
  // const offset = d.getTimezoneOffset()
  const ms = d.getMilliseconds() + 1000 * (d.getSeconds() + 60 * (d.getMinutes() + 60 * d.getHours()))

  const di = new Date(fechaInicio)
  // ojito: En safari as fechas teñen que ir con /, se non nada...
  const df = new Date(d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0'))
  // alert(d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate())
  return df - di + ms
}

export function getControlById (controles, id) {
  let c = controles.filter(o => parseInt(o.id, 10) === parseInt(id, 10))
  if (c && c.length) {
    return c[0]
  }
  return null
}

export const getPrevisionInicioDistancia = (competicion, controles) => {
  if (competicion.prevision_control_iniciar) {
    const inicioPrevision = getControlById(controles, competicion.prevision_control_iniciar)
    if (inicioPrevision) {
      return inicioPrevision.distancia
    }
  }
  return 0
}

export const calculaPrevision = (competicion, controles, sectores, resultado, controlPrevision) => {
  try {
    const control = getControlById(controles, resultado.control_ultimo_id)

    if (sectores && sectores.length && control) {
      let sector = null
      let controlFin = null
      let controlInicio = null
      let j
      for (j = 0; j < sectores.length; j++) {
        controlInicio = controles[0]
        if (sectores[j].inicio) {
          controlInicio = getControlById(controles, sectores[j].inicio)
        }
        controlFin = getControlById(controles, sectores[j].fin)
        // Ojito, non funciona ```a < b < c```
        if ((controlInicio ? controlInicio.distancia : 0) <= control.distancia && control.distancia <= controlFin.distancia) {
          sector = sectores[j]
          break
        }
      }
      let controlCalcular = controlFin
      if (controlPrevision) {
        if ((controlInicio ? controlInicio.distancia : 0) <= controlPrevision.distancia && controlPrevision.distancia <= controlFin.distancia) {
          controlCalcular = controlPrevision
        } else {
          return {
            sector: null,
            tiempo: null,
            tiempoTotal: null,
            control: null,
            distancia: null,
            porcentaje: null,
            inicioDistancia: null,
            // inicioTiempo: previsionInicioTiempo,
            controlUltimo: null
          }
        }
      }

      let tiempo = null
      let distanciaPrevision = null
      let porcentaje = 0
      let tiempo0 = 0
      if (sector) {
        const distancia = control.distancia - controlInicio.distancia
        tiempo0 = parseInt(resultado['control_' + controlInicio.id + '_tiempo'], 10)
        const tiempo1 = parseInt(resultado['control_' + control.id + '_tiempo'], 10)
        if (distancia && tiempo0 && tiempo1) {
          const vel = distancia / (tiempo1 - tiempo0)
          tiempo = (controlCalcular.distancia - controlInicio.distancia) / vel
          const ahora = competicion.fecha_inicio ? msFullAhora(competicion.fecha_inicio) : msAhora()
          // @todo: necesitamos o valor de start no resultado!
          // @fixme: Esto está ben ¿¿¿??? comprobar mais abaixo na versión sin controles...
          let guntime = competicion.guntime
          if (resultado.start) {
            guntime = resultado.start
          } else if (resultado.guntime) {
            guntime = resultado.guntime
          }
          distanciaPrevision = vel * (ahora - (guntime + tiempo0))
          if (control.id === controlCalcular.id) {
            porcentaje = 100
          } else {
            porcentaje = distanciaPrevision / (controlCalcular.distancia - controlInicio.distancia) * 100
          }
        }
      }
      // console.info(distanciaPrevision / 1000)
      if (porcentaje > 100) {
        porcentaje = 100
        distanciaPrevision = controlCalcular.distancia - controlInicio.distancia
      }
      if (distanciaPrevision < 0) {
        porcentaje = 0
        distanciaPrevision = 0
      }

      return {
        sector: sector,
        sector_idx: j,
        tiempo: tiempo, // tiempo del sector
        tiempoTotal: parseInt(tiempo, 0) + parseInt(tiempo0, 10), // tiempo total de carrera
        control: controlCalcular,
        distancia: distanciaPrevision,
        porcentaje: porcentaje,
        inicioDistancia: controlInicio.distancia,
        // inicioTiempo: null,
        controlUltimo: control
      }
    } else {
      const ultimoControl = controles[controles.length - 1]

      let previsionTiempo = null
      let previsionDistancia = null
      let previsionPorcentaje = null
      let previsionInicioTiempo = 0
      let previsionInicioDistancia = 0

      if (control) {
        if (competicion.prevision_control_iniciar) {
          const inicioPrevision = getControlById(controles, competicion.prevision_control_iniciar)
          previsionInicioTiempo = parseInt(
            resultado['control_' + inicioPrevision.id + '_tiempo'],
            10
          )
          previsionInicioDistancia = inicioPrevision.distancia
        }

        if (controlPrevision === null || (typeof controlPrevision) === 'undefined') {
          // si no especificamos un control donde calcular la previsión,
          // lo haremos del último con previsión de marca (será seguramente meta).
          // Comprobamos si alguno de los controles siguientes tiene previsión de marca.
          // Si hay alguno seleccionamos el último
          let _controlPrevision = controles.filter((c) => { return c.prevision && c.distancia > control.distancia })
          controlPrevision = _controlPrevision[_controlPrevision.length - 1]
        }
        if (controlPrevision && controlPrevision.prevision && control.distancia > previsionInicioDistancia) {
          const tiempo = resultado['control_' + control.id + '_tiempo']

          const distanciaEntreControles = control.distancia - previsionInicioDistancia
          const tiempoEntreControles = tiempo - previsionInicioTiempo
          const v = distanciaEntreControles / tiempoEntreControles

          previsionTiempo = previsionInicioTiempo + (controlPrevision.distancia - previsionInicioDistancia) / v

          if (control.tipo === 'META') {
            previsionDistancia = control.distancia
            previsionPorcentaje = 100
          } else {
            let start = competicion.guntime
            if (resultado.guntime) {
              start = resultado.guntime
            }
            if (resultado.start && competicion.tipo === 'TIEMPONETO') {
              start = resultado.start
            }

            if (competicion.fecha_inicio) {
              previsionDistancia = previsionInicioDistancia + v * (msFullAhora(competicion.fecha_inicio) - start - previsionInicioTiempo)
            } else {
              previsionDistancia = previsionInicioDistancia + v * (msAhora() - start - previsionInicioTiempo)
            }
            previsionPorcentaje = previsionDistancia / ultimoControl.distancia * 100
            if (previsionDistancia > ultimoControl.distancia) {
              previsionDistancia = ultimoControl.distancia
              previsionPorcentaje = 100
            }
          }
        }
      }

      if (previsionDistancia === null) {
        if (competicion.mostrar_barra_progreso) {
          if (control) {
            previsionDistancia = control.distancia
            if (control.tipo === 'META') {
              previsionPorcentaje = 100
            } else {
              previsionPorcentaje = control.distancia / ultimoControl.distancia * 100
            }
          } else {
            previsionDistancia = 0
            previsionPorcentaje = 0
          }
        }
      }

      if (previsionDistancia < 0) {
        previsionPorcentaje = 0
        previsionDistancia = 0
      }
      return {
        sector: null,
        tiempo: previsionTiempo,
        tiempoTotal: previsionTiempo,
        control: controlPrevision,
        distancia: previsionDistancia,
        porcentaje: previsionPorcentaje,
        inicioDistancia: previsionInicioDistancia,
        // inicioTiempo: previsionInicioTiempo,
        controlUltimo: control
      }
    }
  } catch (e) {
    console.trace(e)
    return {
      sector: null,
      tiempo: null,
      tiempoTotal: null,
      control: null,
      distancia: null,
      porcentaje: null,
      inicioDistancia: null,
      // inicioTiempo: previsionInicioTiempo,
      controlUltimo: null
    }
  }
}

export const calculateDiferencia = (resultados, dorsal, controlId) => {
      
  let tiempoPrimerPuesto, tiempoDorsalActual, tiempoDiferencia, tiempoMs;  
  let control = 'control_' + controlId + '_tiempo';
  
  if (!Array.isArray(resultados)) {
    return false;
  }

  tiempoPrimerPuesto = resultados[0][control];

  resultados.forEach((resultado) => {
     
      if(resultado.dorsal === dorsal) {
          tiempoDorsalActual = resultado[control] ;
      }
  });

  tiempoDiferencia = tiempoDorsalActual - tiempoPrimerPuesto;

  if (tiempoDiferencia === 0) {
    return "-";
  }

  tiempoMs = "+ " + formatMs(tiempoDiferencia);

  return tiempoMs;
}


// WEBPACK FOOTER //
// ./src/utils/time.js